import apiClient from "../api/client";
import {
  PagedResult,
  ItemBlockMenuItem,
  ItemBlockRecipeItem,
  ItemBlockStoreStatus,
  ItemBlockMenuLinkedDto,
  ItemBlockHistoryItem,
  BlockedItemDto,
  MarkMenuItemBlockRequest,
  UnblockMenuItemRequest,
  MarkRecipeItemBlockRequest,
  UnblockRecipeItemRequest,
} from "../types/itemblocktypes";

export const getItemBlockMenus = (
  pageNumber: number,
  pageSize: number,
  searchTerm?: string,
  storeGroupGuid?: string
) =>
  apiClient.get<PagedResult<ItemBlockMenuItem>>(
    "/api/ItemBlock/grouped",
    { params: { pageNumber, pageSize, searchTerm, storeGroupGuid } }
  );

export const getMenuStoresForItemBlock = (
  menuGuid: string,
  storeNumber?: string,
  status?: "Available" | "Blocked"
) =>
  apiClient.get<ItemBlockStoreStatus[]>(
    `/api/ItemBlock/${menuGuid}/stores`,
    { params: { storeNumber, status } }
  );

export const markMenuItemBlock = (request: MarkMenuItemBlockRequest) =>
  apiClient.post("/api/ItemBlock/markmenuitemblock", request);

export const unblockMenuItem = (request: UnblockMenuItemRequest) =>
  apiClient.post("/api/ItemBlock/unblockmenuitem", request);

export const getItemBlockRecipes = (
  pageNumber: number,
  pageSize: number,
  searchTerm?: string,
  storeGroupGuid?: string
) =>
  apiClient.get<PagedResult<ItemBlockRecipeItem>>(
    "/api/ItemBlock/recipes/grouped",
    { params: { pageNumber, pageSize, searchTerm, storeGroupGuid } }
  );

export const getRecipeStoresForItemBlock = (
  recipeGuid: string,
  storeNumber?: string,
  status?: "Available" | "Blocked"
) =>
  apiClient.get<ItemBlockStoreStatus[]>(
    `/api/ItemBlock/recipe/${recipeGuid}/stores`,
    { params: { storeNumber, status } }
  );

export const markRecipeItemBlock = (request: MarkRecipeItemBlockRequest) =>
  apiClient.post("/api/ItemBlock/markrecipeitemblock", request);

export const unblockRecipeItem = (request: UnblockRecipeItemRequest) =>
  apiClient.post("/api/ItemBlock/unblockrecipeitem", request);

/** ===== Linked Menus (for a recipe) ===== */
export const getMenusByRecipeForItemBlock = (recipeGuid: string) =>
  apiClient.get<ItemBlockMenuLinkedDto[]>(
    `/api/ItemBlock/recipes/${recipeGuid}/menus`
  );

export const getBlockedItems = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  filter: "menu" | "recipe" | "all" = "all",
  storeNumber?: string
) =>
  apiClient.get<PagedResult<BlockedItemDto>>(
    "/api/ItemBlock/items",
    { params: { pageNumber, pageSize, search, filter, storeNumber } }
  );

export const getItemBlockHistory = (
  pageNumber: number,
  pageSize: number,
  menuGuid?: string,
  storeGuid?: string,
  itemName?: string,
  storeNumber?: string,
  action?: "Block" | "Unblock",
  itemType?: "Menu" | "Recipe",
  startDate?: string,
  endDate?: string,
  userGuid?: string
) =>
  apiClient.get<PagedResult<ItemBlockHistoryItem>>(
    "/api/ItemBlock/history",
    {
      params: {
        pageNumber,
        pageSize,
        menuGuid,
        storeGuid,
        itemName,
        storeNumber,
        status: action,
        itemType,
        startDate,
        endDate,
        userGuid,
      },
    }
  );